import React, {Component} from 'react'
import Form from "../../../components/form/Form";
import ReactDOM from "react-dom";
import dateformat from "dateformat";

export default class ProfileItemForm extends Component {

    static ItemType = 'Item';

    static FormClass = 'talent-role-form add-talent-form ';

    static ShowProfilePreview = false;
    static TypeConfig = {
        icon: null,
        color: null
    };

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
        this.state = {
            model: this.getModelFromProps()
        }
    }

    canEdit() {
        return true
    }

    creatingNewItem() {
        return !TB.keys(this.getModelFromProps()).length
    }

    getModelFromProps() {
        return {...(this.props.model || {})}
    }

    hasChanged() {
        return !TB.isEqual(this.state.model, this.getModelFromProps())
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        return []
    };

    static months = () => [
        {
            label: 'Month',
            value: '',
            disabled: false
        }
    ].concat([
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
    ].map((month, index) => {
            return {
                label: String(month),
                value: index + 1
            };
        }
    ));
    /**
     * The months for date select dropdown
     */
    monthOptions = TB.memoize(ProfileItemForm.months);

    static years = () => {
        return [
            {
                label: 'Year',
                value: '',
                disabled: false
            }
        ].concat(TB.rangeRight(1900, (new Date()).getFullYear() + 1)
            .map(year => {
                    return {
                        label: String(year),
                        value: year
                    };
                }
            )
        );
    };
    /**
     * The year for date select dropdown
     */
    yearOptions = TB.memoize(ProfileItemForm.years);

    setDateFromInputs(model, dateField) {
        let newDate = model[dateField];
        let year = model[dateField + '_year'];
        let month = model[dateField + '_month'];

        if (!TB.isNaN(year) && !TB.isNaN(month)) {
            newDate = new Date(year, month - 1, 1);
        } else if (!TB.isNaN(year)) {
            newDate = new Date(year, 1, 1);
        } else if (TB.isDefined(model[dateField])) {
            newDate = undefined;
        }

        let format = 'mm-yyyy';

        if (newDate && dateformat(newDate, format) !== dateformat(model[dateField], format)) {
            return {[dateField]: newDate};
        } else if (newDate !== model[dateField]) {
            return {[dateField]: newDate};
        }
        return {};
    }

    validateDateBeforeToday(field, display = null) {
        if (!display) display = TB.upperFirst(TB.lowerCase(field));

        let errors = {};
        if (this.state.model[field]) {
            errors = {[field]: null};
            // Check earned date after today
            if (this.state.model[field] > (new Date())) {
                errors[field] = display + " must be before today"
            }
        }
        return errors;
    }

    validateDateAfterDate(field, before_field, error = null) {
        if (!error) error = TB.trans('talent.school_form.validations.before_start_date');

        let errors = {};
        if (this.state.model[field]) {
            errors = {[field]: null};
            // Check end date before start
            if (this.state.model[field] < this.state.model[before_field]) {
                errors[field] = error;
            }
        }

        return errors;
    }

    /**
     * The fields mapping for the form
     */
    getFormFields = () => {
        let fields = this.formFields();

        let {
            disabled, isEditing
        } = this.props
        let model = this.state.model;

        let hiddenStyle = {
            height: 0,
            width: 0,
            zIndex: -10,
            opacity: 0,
            position: 'absolute',
            left: -9999
        }
        return TB.map(fields, (formFieldSection) => {

            let visibleFields = {};
            let fieldNames = Object.keys(formFieldSection.fields);

            let sectionHasVisibleField = false;
            TB.map(fieldNames, key => {
                let field = formFieldSection.fields[key];

                visibleFields[key] = {
                    ...field,
                    disabled: disabled || !isEditing || field.disabled
                };

                let hidden = TB.isDefined(field.hideVisibility) ? field.hideVisibility : (!field.required && !model[key] && !isEditing);

                if (hidden) {
                    visibleFields[key].style = hiddenStyle;
                } else sectionHasVisibleField = true;
            })

            if (!sectionHasVisibleField) {
                formFieldSection.style = hiddenStyle;
            }

            return {
                ...formFieldSection,
                fields: visibleFields
            }
        })
    };

    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    async onSubmit(model = this.state.model) {
        let response = await this.props.onSubmit({
            ...this.getModelFromProps(),
            ...model
        });

        if (response) {
            await TB.toast("Profile Updated")
        }
        return response
    }

    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {
        return new Promise((resolve, reject) => {
            this.setState({model}, resolve);
        });
    }

    /**
     * Get styles based on type config
     *
     * @returns {Object}
     */
    static getFormStyle() {
        let config = this.TypeConfig;

        return {
            borderTop: `5px solid ${config.color || 'white'}`,
        }
    }

    /**
     * Get styles based on type config
     *
     * @returns {Object}
     */
    static getIconStyle() {
        let config = this.TypeConfig;

        return {
            backgroundColor: `${config.color || 'white'}`,
        }
    }

    /**
     * The validate
     */
    forceValidate() {
        return this.invalidFields()
    }

    /**
     * The first invalid field
     */
    invalidFields() {
        if (!this.formRef.current) {
            return false
        }
        return this.formRef.current.forceValidate();
    }

    /**
     * if validated, submit the form
     */
    async validateAndSave() {
        let elem = this.invalidFields();

        if (elem) {
            const node = ReactDOM.findDOMNode(elem);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        } else {

            let response = await this.onSubmit()
            console.log('onSubmit', response);

        }
    }

    /**
     * Ask the user to confirm throwing away their unsaved edits
     *
     * @returns {Promise<boolean>}
     */
    async confirmDiscardChanges() {
        let title = TB.trans('talent.profile_item_form.alerts.cancel_header');
        let message = TB.trans('talent.profile_item_form.alerts.cancel_body');

        return TB.alert(
            'error',
            String(title),
            String(message),
            [
                {title: String(TB.trans('talent.profile_item_form.alerts.btn_ok_txt'))},
                {title: String(TB.trans('talent.profile_item_form.alerts.btn_cancel_txt'))},
            ]
        );
    }

    /**
     * Handles the cancel button. A never saved item is removed from the list,
     * an existing item is rolled back to its last saved state.
     *
     * @returns void
     */
    async onCancel() {

        if (!this.hasChanged() || this.creatingNewItem()) {
            if (this.creatingNewItem()) {
                // Submitting an empty model removes the placeholder from the list
                await this.props.onSubmit()
            }
            return this.props.onEditing(false);
        }

        let shouldCancel = await this.confirmDiscardChanges();

        if (shouldCancel) {
            let model = this.getModelFromProps();

            await this.formRef.current.forceReset(model);
            await this.formRef.current.updateInputsWithValue(model);
            return this.props.onEditing(false);
        }
    }

    /**
     * Confirm deletion
     */
    async onDelete() {
        let shouldDelete = await TB.alert(
            'error',
            `Delete ${this.constructor.ItemType}?`,
            'Are you sure you want to delete this? Any unsaved changes will be removed.', [
                {title: 'Yes, delete'},
                {title: 'Cancel'},
            ]
        )

        if (shouldDelete) {
            let response = await this.props.onSubmit();
            if (response) {
                await TB.toast("Profile Updated")
            }
        }
    }

    shouldShowProfilePreview() {
        return !this.props.isEditing && this.constructor.ShowProfilePreview && TB.isDefined(this.state.model?.id);
    }

    renderProfilePreview() {
        return null;
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {

        let {
            model
        } = this.state;

        let {
            disabled,
            isEditing,
            formTitle,
            canEdit
        } = this.props;

        let talentClass = this.constructor.FormClass;
        if (!canEdit) {
            talentClass += "no-edit "
        }

        talentClass += (isEditing ? "active-edit" : "inactive-edit")


        return (
            <div className={talentClass} style={this.constructor.getFormStyle()}>

                {this.shouldShowProfilePreview() ? (
                    <div className="wripple-form">
                        <div className="form-container">
                            {this.renderTitle()}
                            {this.constructor.renderIcon()}

                            {this.renderProfilePreview()}
                            {this.renderFormFooter()}
                        </div>
                    </div>
                ) : (
                    <Form
                        ref={this.formRef}
                        key={formTitle}
                        title={this.renderTitle()}
                        subtitle={null}
                        showRequired
                        preventChangeWhileDisabled
                        submitButton={false}
                        onChange={this.onChange.bind(this)}
                        model={model}
                        fields={this.getFormFields()}
                        isDisabled={disabled || !isEditing}>

                        {this.constructor.renderIcon()}

                        {this.renderFormFooter()}


                    </Form>
                ) }
            </div>
        );
    }

    /**
     * Extra Content
     *
     * @returns {div}
     */
    renderFormFooter() {

        let {
            disabled,
            isEditing,
        } = this.props;

        return (
            <div className="role-form-footer">

                {isEditing ? (
                    <div className="edit-btn-row">
                        <button
                            className="btn btn-primary mr-3"
                            disabled={disabled}
                            onClick={() => this.validateAndSave()}
                            type="button">
                            {TB.trans('talent.profile_item_form.save_btn')}
                        </button>
                        <button
                            className="btn btn-outline-dark"
                            disabled={disabled}
                            type="button" formNoValidate
                            onClick={() => this.onCancel()}
                        >
                            {TB.trans('talent.profile_item_form.cancel_btn')}
                        </button>
                    </div>
                ) : this.renderFormFooterInfo()}


                {(!isEditing && this.canEdit()) ? (
                    this.renderEditFormButton()
                ) : (!this.creatingNewItem() && (
                        <button className="btn btn-link"
                                disabled={disabled}
                                type="button"
                                onClick={() => this.onDelete()}>
                            {TB.trans('talent.profile_item_form.delete_btn')} {this.constructor.ItemType}
                        </button>
                    )
                )}

            </div>
        );
    }


    static renderIcon() {
        let icon = this.TypeConfig.icon;

        if (!icon) return null;

        return (
            <div className="form-profile-icon" style={this.getIconStyle()}>

                <i className={icon}/>

            </div>
        )
    }

    /**
     * Show info on bottom of panel
     *
     * @returns {div}
     */
    renderFormFooterInfo() {
        return null;
    }
    /**
     * Edit button for form
     *
     * @returns {div}
     */
    renderEditFormButton() {
        return (
            <button
                className="btn btn-link"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}>
                {TB.trans('talent.profile_item_form.edit_btn')} {this.constructor.ItemType}
            </button>
        );
    }

    static renderIcon() {
        let icon = this.TypeConfig.icon;

        if (!icon) return null;

        return (
            <div className="form-profile-icon" style={this.getIconStyle()}>

                <i className={icon}/>

            </div>
        )
    }

    renderTitle() {
        return (
            <div className="form-title-section">
                <div className="step-title-content self-stretch flex-row justify-between items-center mb-4 pr-0">
                    <div className="flex-grow">
                        <h3 className="form-title mb-0">
                            {this.props.formTitle}
                        </h3>
                    </div>
                    {/*{(!this.props.isEditing && this.canEdit()) && (*/}
                    {/*    <button*/}
                    {/*        className="btn btn-link py-0"*/}
                    {/*        disabled={this.props.disabled}*/}
                    {/*        type="button" onClick={() => this.props.onEditing(true)}>*/}
                    {/*        {TB.trans('talent.profile_item_form.edit_btn')} {this.constructor.ItemType}*/}
                    {/*    </button>*/}
                    {/*)}*/}

                </div>
            </div>
        )
    }
};

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};